<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LcznUu/tc-custom/9781646042760.jpg?1720280502125" alt="This image is the cover for the book Teach Your Dog to Talk"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Teach Your Dog to Talk
      </h1>
      <p class="bookDescription body article font2">
        <b>Train your dog to communicate through more than just barks—the first beginner’s guide to pet training with speech buttons and soundboards!</b><br/><br/><i>Teach Your Dog to Talk</i> is an easy-to-use guide to exploring Augmentative and Alternative Communication (AAC). Inspired by the discovery that dogs can use AAC to communicate with their humans, this book is perfect for pet owners looking to foster a deeper connection with their dog through “speech training.”<br/><br/> Explore this fun (and funny!) endeavor as you learn the basic setup of currently available AAC devices and best practices for getting started, and enjoy notable achievements by some of the internet’s favorite “talking” dogs. The book also answers frequently asked questions, discusses common mistakes, and offers do's and don’ts. Create a whole new bond with your beloved four-legged friend with the tips and tricks offered in this first-of-its-kind handbook. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Rocha
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e12d1f98